import React from 'react'
import classNames from "classnames"

import QuizRheostat from '../../Controls/Rheostat'
import QuizChoice from '../../Controls/Choice'
import SocialSharing from '../../../SocialSharing'
import Countdown from "../../../Countdown"

import back from '../../../../assets/images/facts/17/protect/back.jpg'
import face from '../../../../assets/images/facts/17/protect/face.jpg'

import mark1 from '../../../../assets/images/facts/17/protect/marks/mark-2-2000.jpg'
import mark2 from '../../../../assets/images/facts/17/protect/marks/mark-3-2000.jpg'
import mark3 from '../../../../assets/images/facts/17/protect/marks/mark-4-2000.jpg'
import mark4 from '../../../../assets/images/facts/17/protect/marks/mark-1-2000.jpg'


import './style.scss'

/*
<QuizProvider quiz={{
  results: {
    0: {
      title: 'То чувство, когда...',
      text: 'Не ответил на вопросы правильно.'
    },
    1: {
      title: 'Один вопрос!',
      text: 'Ну это уже что-то.'
    },
    2: {
      title: 'Больше одного вопроса',
      text: 'Текст под заголовком'
    }
  },
  questions: [
    {
      title: 'Первый вопрос',
      text: 'Правильный ответ — 5',
      correctAnsweredText: 'Текст если ответили правильно',
      wrongAnsweredText: 'Текст если ответили неправильно',
      rheostat: {
        nearCorrect: 0,
        correct: [true, false, false],
        values: [5,6,7]
      },
    },
    {
      title: 'Второй вопрос',
      text: 'Правильный ответ — первый',
      choice: [{
        text: 'Первый ответ',
        correct: true
      }, {
        text: 'Второй ответ',
        correct: false
      }],
    },
    {
      title: 'Второй вопрос',
      text: 'Правильный ответ — 7',
      type: 'choice',
      rheostat: {
        nearCorrect: 1,
        correct: [false, false, false, false, false, false, true, false, false],
        values: [1,2,3,4,5,6,7,8,9,10]
      },
    }
  ]
}} />

*/

class ProtectQuiz extends React.Component {
  render() {
    let {
      mark1,
      mark2,
      mark3,
      mark4,
      protect,
      preShowBanknoteMark1,
      preShowBanknoteMark2,
      preShowBanknoteMark3,
      preShowBanknoteMark4,
      onBanknoteMouseOver,
      onBanknoteMouseLeave,
      banknoteFlipped,
      findMark } = this.props

    return (
      <>
        { protect.fSide.map(item => {
          if (item.id === 1) {
            return <div key={item.id} className={classNames(`mark-container ${'mark-container-'+item.id}`)}>
              <img
                src={mark1}
                onClick={() => findMark(item.id)}
                onMouseOver={() => {onBanknoteMouseOver(item.id)}}
                onMouseLeave={() => {onBanknoteMouseLeave(item.id)}}
                className={classNames(
                  'mark',
                  {
                    'mark-1': preShowBanknoteMark1,
                    'foundMark-1': item.found
                  })}
              />
              <div className={classNames('mark-answer', {'foundMark-1': item.found && banknoteFlipped})}>
                <div className="mark-count" dangerouslySetInnerHTML={{__html: item.counter}}/>
                <div className="mark-desc" dangerouslySetInnerHTML={{__html: item.desc}}/>
              </div>
            </div>
          }

          if (item.id === 2) {
            return <div key={item.id} className={classNames(`mark-container ${'mark-container-'+item.id}`)}>
              <img
                src={mark2}
                onClick={() => findMark(item.id)}
                onMouseOver={() => {onBanknoteMouseOver(item.id)}}
                onMouseLeave={() => {onBanknoteMouseLeave(item.id)}}
                className={classNames(
                  'mark',
                  {
                    'mark-2': preShowBanknoteMark2,
                    'foundMark-2': item.found
                  })}
              />
              <div className={classNames('mark-answer', {'foundMark-2': item.found && banknoteFlipped})}>
                <div className="mark-count" dangerouslySetInnerHTML={{__html: item.counter}}/>
                <div className="mark-desc" dangerouslySetInnerHTML={{__html: item.desc}}/>
              </div>
            </div>
          }

          if (item.id === 3) {
            return <div key={item.id} className={classNames(`mark-container ${'mark-container-'+item.id}`)}>
              <img
                src={mark3}
                onClick={() => findMark(item.id)}
                onMouseOver={() => {onBanknoteMouseOver(item.id)}}
                onMouseLeave={() => {onBanknoteMouseLeave(item.id)}}
                className={classNames(
                  'mark',
                  {
                    'mark-3': preShowBanknoteMark3,
                    'foundMark-3': item.found
                  })}
              />
              <div className={classNames('mark-answer', {'foundMark-3': item.found && banknoteFlipped})}>
                <div className="mark-count" dangerouslySetInnerHTML={{__html: item.counter}}/>
                <div className="mark-desc" dangerouslySetInnerHTML={{__html: item.desc}}/>
              </div>
            </div>
          }

        })}
        { protect.bSide.map(item => {
          return <div key={item.id} className={classNames(`mark-container ${'mark-container-'+item.id}`)}>
            <img
              src={mark4}
              onClick={() => findMark(item.id)}
              onMouseOver={() => {onBanknoteMouseOver(item.id)}}
              onMouseLeave={() => {onBanknoteMouseLeave(item.id)}}
              className={classNames(
                'mark',
                {
                  'mark-4': preShowBanknoteMark4,
                  'foundMark-4': item.found
                })}
            />
            <div className={classNames('mark-answer', {'foundMark-4': item.found && !banknoteFlipped})}>
              <div className="mark-count" dangerouslySetInnerHTML={{__html: item.counter}}/>
              <div className="mark-desc" dangerouslySetInnerHTML={{__html: item.desc}}/>
            </div>
          </div>
        })}
      </>
    )
  }
}

class QuizProvider extends React.Component {
  constructor(props) {
    super(props);

    this.questionsLength = this.props.quiz.questions.length

    if (props.quiz.questions.length && props.quiz.questions[0].protect) {
      props.quiz.questions[0].protect.fSide.map(item => item.found = false);
      props.quiz.questions[0].protect.bSide.map(item => item.found = false);
    }

    this.state = {
      showResults: false,
      rerender: true,
      activeQuestion: 0,
      showCorrect: false,
      readyToCommit: false,
      answerCommited: false,
      isCorrectAnswered: false,
      isNextQuestionExists: this.questionsLength > 1,
      correctQuestions: [],
      quizStarted: false,
      banknoteFlipped: true,
      preShowBanknoteMark1: false,
      preShowBanknoteMark2: false,
      preShowBanknoteMark3: false,
      preShowBanknoteMark4: false,
      foundOne: false,
      markCounter: 0
    }

    let propres = this.props.quiz.results
    this.results = []
    let q = 0
    for (let i = 0; i < this.questionsLength + 1; i++) {
      if (propres[i]) {
        q = i
      }
      this.results.push(propres[q])
    }


    this.quizChoice = React.createRef()
    this.quizRheostat = React.createRef()

    this.handlers = {
      findMark: this.findMark.bind(this),
      onBanknoteMouseOver: this.onBanknoteMouseOver.bind(this),
      onBanknoteMouseLeave: this.onBanknoteMouseLeave.bind(this),
    }
  }

  commitAnswer() {
    this.props.refreshScrollArea()

    let quizChoiceCorrect = false,
        quizRheostatCorrect = false

    if (this.quizChoice.current) {
      quizChoiceCorrect = this.quizChoice.current.state.isCorrect
    }
    if (this.quizRheostat.current) {
      quizRheostatCorrect = this.quizRheostat.current.state.isCorrect
    }

    let isQuestionCorrectAnswered = quizChoiceCorrect || quizRheostatCorrect

    if (isQuestionCorrectAnswered) {
      this.setState({
        correctQuestions: [
          ...this.state.correctQuestions,
          this.state.activeQuestion
        ]
      })
    }

    this.setState({ showCorrect: true, answerCommited: true, isCorrectAnswered: isQuestionCorrectAnswered, })

    this.forceUpdate()
  }

  nextQuestion() {
    this.setState({
      isNextQuestionExists: (this.state.activeQuestion + 1) !== this.questionsLength - 1,
      activeQuestion: this.state.activeQuestion + 1,
      showCorrect: false,
      readyToCommit: false,
      answerCommited: false,
      rerender: false
    })
    window.setTimeout(() => {
      this.setState({
        rerender: true
      })
    })

    this.forceUpdate()
  }

  showResults() {
    this.setState({
      quizStarted: false,
      showResults: true
    })
  }

  quizStart() {
    this.props.refreshScrollArea()
    document.querySelector('.modal-content').classList.add('questions')

    if (document.querySelector('.scrollarea-content')) {
      document.querySelector('.scrollarea-content').removeAttribute('style')
    }

    if (this.props.quiz.questions && this.props.quiz.questions[0].protect) {
      this.props.startProtectQuiz()
    } else {
      this.setState({
        showResults: false,
        rerender: true,
        activeQuestion: 0,
        showCorrect: false,
        readyToCommit: false,
        answerCommited: false,
        isCorrectAnswered: false,
        isNextQuestionExists: this.questionsLength > 1,
        correctQuestions: [],
        quizStarted: true,
        banknoteFlipped: true,
        preShowBanknoteMark1: false,
        preShowBanknoteMark2: false,
        preShowBanknoteMark3: false,
        preShowBanknoteMark4: false,
        foundOne: false,
        markCounter: 0
      })
    }
  }

  answerReadyToCommit(state) {
    this.setState({ readyToCommit: state })
  }

  flipSide() {
    this.setState({banknoteFlipped: !this.state.banknoteFlipped})
  }

  onBanknoteMouseOver(id) {
    switch(id) {
      case 1:
        this.setState({preShowBanknoteMark1: true})
        break
      case 2:
        this.setState({preShowBanknoteMark2: true})
        break
      case 3:
        this.setState({preShowBanknoteMark3: true})
        break
      case 4:
        this.setState({preShowBanknoteMark4: true})
        break
    }
  }

  onBanknoteMouseLeave(id) {
    switch(id) {
      case 1:
        this.setState({preShowBanknoteMark1: false})
        break
      case 2:
        this.setState({preShowBanknoteMark2: false})
        break
      case 3:
        this.setState({preShowBanknoteMark3: false})
        break
      case 4:
        this.setState({preShowBanknoteMark4: false})
        break
    }
  }

  foundMarkState(id, item) {
    if (item.id === id && !item.found) {
      this.setState({markCounter: this.state.markCounter + 1})
      item.found = true
      item.counter = this.state.markCounter + 1
    }
  }

  findMark(id) {
    this.props.quiz.questions[0].protect.fSide.map(item => {
      this.foundMarkState(id, item);
    })

    this.props.quiz.questions[0].protect.bSide.map(item => {
      this.foundMarkState(id, item);
    })
  }

  render() {
    const { questionsLength, quizChoice, quizRheostat, results } = this
    const {
      activeQuestion,
      showCorrect,
      readyToCommit,
      answerCommited,
      rerender,
      isCorrectAnswered,
      isNextQuestionExists,
      showResults,
      correctQuestions,
      quizStarted
    } = this.state
    const { quiz, isProtectQuiz } = this.props
    const question = quiz.questions[activeQuestion]
    const rheostat = question.rheostat
    const protect = question.protect
    const intro = quiz.intro
    const choice = question.choice
    const { correctAnsweredText, wrongAnsweredText } = question

    let renderAnswer = () => {
      if (rerender) {
        return (
          <div>
            {choice ?
              <QuizChoice
                ref={quizChoice}
                answerReadyToCommit={ (state) => { this.answerReadyToCommit(state) } }
                showCorrect={showCorrect}
                choice={choice} />
            : ''}

            {rheostat ?
              <QuizRheostat
                ref={quizRheostat}
                answerReadyToCommit={ (state) => { this.answerReadyToCommit(state) } }
                nearCorrect={rheostat.nearCorrect}
                showCorrect={showCorrect}
                correct={rheostat.correct}
                values={rheostat.values} />
            : ''}

            {protect ?
              'hay'
              : ''}
          </div>
        )
      }
    }

    let markFace = () => {
      if (rerender) {
        return (
          <ProtectQuiz
            mark1={mark1}
            mark2={mark2}
            mark3={mark3}
            protect={protect}
            preShowBanknoteMark1={this.state.preShowBanknoteMark1}
            preShowBanknoteMark2={this.state.preShowBanknoteMark2}
            preShowBanknoteMark3={this.state.preShowBanknoteMark3}
            preShowBanknoteMark4={this.state.preShowBanknoteMark4}
            markCounter={this.state.markCounter}
            banknoteFlipped={this.state.banknoteFlipped}
            {...this.handlers}
          />
        )
      }
    }

    let markBack = () => {
      if (rerender) {
        return (
          <ProtectQuiz
            mark4={mark4}
            protect={protect}
            preShowBanknoteMark1={this.state.preShowBanknoteMark1}
            preShowBanknoteMark2={this.state.preShowBanknoteMark2}
            preShowBanknoteMark3={this.state.preShowBanknoteMark3}
            preShowBanknoteMark4={this.state.preShowBanknoteMark4}
            markCounter={this.state.markCounter}
            banknoteFlipped={this.state.banknoteFlipped}
            {...this.handlers}
          />
        )
      }
    }

    let answer = renderAnswer()
    let markFaceSide = markFace()
    let markBackSide = markBack()

    return (
      <div className="quiz">
        {showResults ?
          <div className="quiz-inner">
            <div className="quiz-content">
              <div className="quiz-question">
                <div className="title" dangerouslySetInnerHTML={{ __html: correctQuestions.length + ' из ' + questionsLength + '. ' + results[correctQuestions.length] ? results[correctQuestions.length].title : '' }}/>
                <p dangerouslySetInnerHTML={{__html: results[correctQuestions.length] ? results[correctQuestions.length].text : ''}}/>
              </div>
            </div>

            <div className="quiz-action">
              <button className="white" onClick={() => {this.quizStart()}}>Пройти еще раз</button>
            </div>

            <br/>

            <div className="quiz-action">
              <SocialSharing  isQuiz mainText={intro.text} />
            </div>
          </div>
        :
          <div className="quiz-fh">
            {quizStarted || isProtectQuiz || rheostat ?
              protect ?
                <div className='protect-quiz'>
                  <div className='one-line'>
                    <Countdown markCounter={this.state.markCounter} />
                    <span className='quiz-answer-count' dangerouslySetInnerHTML={{ __html: `${this.state.markCounter}/4` }}/>
                  </div>
                  <h1 className="description" dangerouslySetInnerHTML={{ __html: question.title }}/>
                  <div className={classNames('image-wrapper', {'flipped' : this.state.banknoteFlipped})}>
                    <div
                      className="signs-wrapper"
                    >
                      { this.state.banknoteFlipped ? markFaceSide : markBackSide }
                      <img src={ this.state.banknoteFlipped ? face : back } alt="banknote"/>
                    </div>
                    <div onClick={() => {this.flipSide()}} className="flipper"/>
                  </div>
                </div>
                :
                <div className="quiz-inner">
                  <div className="quiz-content">
                    {
                      (questionsLength > 1) ?
                        <div className="quiz-header">
                          <div className="title">{activeQuestion + 1}/{questionsLength}</div>
                        </div>
                        : ''
                    }
                    <div className="quiz-question">
                      <div className="title" dangerouslySetInnerHTML={{ __html: question.title }}/>
                      {!answerCommited ? <p dangerouslySetInnerHTML={{ __html: question.text }}/> : ''}
                      {correctAnsweredText && answerCommited && isCorrectAnswered ? <p className="quiz-text-correct" dangerouslySetInnerHTML={{ __html: correctAnsweredText }}/> : ''}
                      {wrongAnsweredText && answerCommited && !isCorrectAnswered ? <p className="quiz-text-wrong" dangerouslySetInnerHTML={{ __html: wrongAnsweredText }}/> : ''}

                      {quizChoice.current && choice && choice[quizChoice.current.state.choosen] && choice[quizChoice.current.state.choosen].correctAnsweredText && answerCommited && isCorrectAnswered ? <p className="quiz-text-correct" dangerouslySetInnerHTML={{ __html: choice[quizChoice.current.state.choosen].correctAnsweredText }}/> : ''}
                      {quizChoice.current && choice && choice[quizChoice.current.state.choosen] && choice[quizChoice.current.state.choosen].wrongAnsweredText && answerCommited && !isCorrectAnswered ? <p className="quiz-text-wrong" dangerouslySetInnerHTML={{ __html: choice[quizChoice.current.state.choosen].wrongAnsweredText }}/> : ''}
                    </div>
                    <div className="quiz-answer">
                      {answer}
                    </div>
                  </div>
                  <div className="quiz-action">
                    {readyToCommit && !answerCommited ? <button className="white" onClick={() => {this.commitAnswer()}}>Проверить</button> : ''}
                    {answerCommited && isNextQuestionExists ? <button className="white" onClick={() => {this.nextQuestion()}}>Следующий вопрос</button> : ''}
                    {
                      answerCommited && !isNextQuestionExists && rheostat ?
                        <div className="quiz-action">
                          <SocialSharing isQuiz mainText={intro.text} />
                        </div>
                        :
                      answerCommited && !isNextQuestionExists ? <button className="white" onClick={() => {this.showResults()}}>Закончить тест</button> : ''
                    }
                  </div>
                </div>
             :
               <div className="quiz-inner">
                 <div className="quiz-content">
                   <div className="quiz-question">
                     <div className="title" dangerouslySetInnerHTML={{ __html: intro.title }}/>
                     <p dangerouslySetInnerHTML={{ __html: intro.text }}/>
                   </div>
                 </div>
                 <div className="quiz-action">
                   <button onClick={ () => { this.quizStart() } } className="white">
                     Начать тест
                   </button>
                 </div>
               </div>
             }
          </div>
        }
      </div>
    )
  }
}

export default QuizProvider
